<template>
    <Modal v-model="visible" :loading="modalLoading" closable mask-closable :title="getTranslation('e058')" width="40">
        <div>
            <Row style="margin-bottom:8px;">
                <Col :span="8">
                    <Checkbox v-model="exportWithCurve" @on-change="changeWithCurve">{{ getTranslation("e036") }}</Checkbox>
                </Col>
            </Row>
        </div>
        <div slot="footer">
            <Row type="flex" class="menu-actions">
                <Col flex="1" class="flex-right">
                <Button type="text" @click="cancel" icon="md-close">{{ getTranslation('b182') }}</Button>&nbsp;
                <Button type="primary" @click="ok" icon="md-checkmark">{{ getTranslation('k025') }}</Button>
                </Col>
            </Row>
        </div>
    </Modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'RecordCol', // 组件名称
    components: {
        
    },
    props: {
        propVisible: Boolean,
    },

    computed: {
        ...mapGetters(['getTranslation']),
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },      

    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.init();
            }
        },
    },
    data() {
        return {
            modalLoading: true,
            mac: '',
            exportWithCurve:false,           
        }
    },

    created() {
        this.mac = this.$route.query.mac
        this.init();

    },
    methods: {
        init() {
            this.exportWithCurve = localStorage.getItem('record.withCurve') == 'true' ;
        },       
      
        ok() {
            this.$emit('record-export',{exportWithCurve:this.exportWithCurve});
            this.visible = false;
        },
        cancel() {
            this.visible = false;
        },
        changeWithCurve(status){     
            localStorage.setItem('record.withCurve',status)
        },  

    },

}



</script>
<style></style>
<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');
</style>